import { createSelector } from '@reduxjs/toolkit';
import { freqAnalysisSlice } from './slice';
import { RootState } from "../../app/state";

export const selectFreqAnalysisState = (state: RootState) => state[freqAnalysisSlice.name];

export const selectChannelsForD3 = createSelector(
  selectFreqAnalysisState,
  (freqAnalysisState) => freqAnalysisState.channelsForD3
);

export const selectDeviceListForD3 = createSelector(
  selectFreqAnalysisState,
  (freqAnalysisState) => freqAnalysisState.deviceList
);

export const selectRangeWithUnits = createSelector(
  selectFreqAnalysisState,
  (freqAnalysisState) => freqAnalysisState.range
);

export const selectStepCount = createSelector(
  selectFreqAnalysisState,
  (freqAnalysisState) => freqAnalysisState.stepCount
);

export const selectMaxNumberOfDevices = createSelector(
  selectFreqAnalysisState,
  (freqAnalysisState) => freqAnalysisState.maxNumberOfDevices
);

export const selectAnalysisTechnologyId = createSelector(
  selectFreqAnalysisState,
  (freqAnalysisState) => freqAnalysisState.selectedTechnologyId
);

export const selectAnalysisDeviceId = createSelector(
  selectFreqAnalysisState,
  (freqAnalysisState) => freqAnalysisState.selectedDeviceId
);

export const selectAnalysisFiltersWereSelected = createSelector(
  selectFreqAnalysisState,
  (state) => !!state.stepCount
)